import React from 'react';
import './onboard-table-style.scss';

const OnboardTable = (props) => {

    const {header, body} = props;

    const renderHeader = () => {
        if (header !== undefined)
            return header.map((value, index) => {
                if (index === 0) return <div key={index} className="onboard-table-header-sub">{value}</div>;
                else return <div key={index}
                                 className="onboard-table-header-sub onboard-table-header-sub-result">{value}</div>;
            })
        else
            return <></>;
    }

    const renderBody = () => {
        if (body !== undefined)
            return body.map((value, index) => {
                return (
                    <div key={index} className={'onboard-table-body ' + (index % 2 ? 'onboard-table-gray' : '')}>
                        <div className="onboard-table-column">
                            <div className="onboard-table-column-text">{value.text}</div>
                            {value.subtext && (<div className="onboard-table-column-sub-text">({value.subtext})</div>)}
                        </div>
                        <div className="onboard-table-column-result">{value.result}</div>
                    </div>
                )
            })
        else
            return <></>;
    }

    return (
        <div className="onboard-table-root">
            <div
                className={'onboard-table-header ' + (header !== undefined ? '' : ' onboard-table-header-hidden')}>
                {renderHeader()}
            </div>
            {renderBody()}
        </div>
    )
};

export default OnboardTable;
